import { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { savApi } from './savApi';
import { errMsg, eur } from '../invoice/api';

export function SavPreparations({ onOpen, refreshKey }) {
    const [rows, setRows] = useState([]);
    useEffect(() => { savApi.preparations().then(setRows).catch(() => setRows([])); }, [refreshKey]);
    if (!rows.length) return null;
    return (
        <div className="card p-4 mb-6 space-y-2" data-testid="sav-preparations">
            <p className="text-[13px] font-semibold text-gray-700">Préparations à valider ({rows.length})</p>
            {rows.map(p => (
                <div key={p.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-sky-100 bg-sky-50/50 px-3 py-2 text-[12px]" data-testid={`sav-prep-${p.id}`}>
                    <span className="min-w-0 break-words"><b className="font-mono">{p.body?.vehicule?.immatriculation || p.body?.vehicule_label || '—'}</b> {p.body?.vehicule?.marque || ''} {p.body?.vehicule?.modele || ''} — {p.body?.nature} · {eur(p.body?.montant_ttc)} · préparé par {p.par}</span>
                    <Button size="sm" variant="outline" className="h-8 text-[12px]" onClick={() => onOpen(p)} data-testid={`sav-prep-open-${p.id}`}>Reprendre</Button>
                </div>
            ))}
        </div>
    );
}

export function SavRapprochements({ onChanged }) {
    const [rows, setRows] = useState([]);
    const load = useCallback(() => savApi.rapprochements().then(setRows).catch(() => setRows([])), []);
    useEffect(() => { load(); }, [load]);
    if (!rows.length) return null;
    const go = async (r) => {
        if (!window.confirm(`Rapprocher le dossier SAV ${r.immatriculation} du véhicule ${r.vehicule.nom || ''} ?\nLe dossier est conservé, aucun doublon n'est créé et les montants ne changent pas.`)) return;
        try { await savApi.rapprocher(r.sav_id, r.vehicule.id); toast.success('Dossier rapproché'); load(); onChanged?.(); } catch (e) { toast.error(errMsg(e)); }
    };
    return (
        <div className="card p-4 mb-6 space-y-2" data-testid="sav-rapprochements">
            <p className="text-[13px] font-semibold text-gray-700">Véhicules désormais enregistrés : rapprochement proposé</p>
            {rows.map(r => (
                <div key={r.sav_id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-gray-100 px-3 py-2 text-[12px]" data-testid={`sav-rappro-${r.sav_id}`}>
                    <span className="min-w-0 break-words">SAV <b className="font-mono">{r.immatriculation}</b> ({r.marque} {r.modele}) ↔ {r.vehicule.nom || ''} · {r.vehicule.date_vente ? `vendu le ${r.vehicule.date_vente}` : 'en stock'}</span>
                    <Button size="sm" className="h-8 text-[12px] bg-[#6366F1] hover:bg-[#4F46E5] text-white" onClick={() => go(r)} data-testid={`sav-rappro-confirm-${r.sav_id}`}>Confirmer</Button>
                </div>
            ))}
        </div>
    );
}
